import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { mustMatch } from './must-watch.validators';
import { CommonServiceService } from '../../services/common-service.service';
import { Router } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from '../../alert/alert.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  titleAlert: string = 'This field is required';
  options = {
    autoClose: false,
    keepAfterRouteChange: true
  };
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  showDropdown: boolean = false;
  selectedOption: string = "I am here for*";

  constructor(private formBuilder: FormBuilder,
    private service: CommonServiceService,
    private router: Router,
    private _matDialog: MatDialog,
    public alertService: AlertService,
    private _snackBar: MatSnackBar ) { }

  ngOnInit() {
    let emailregex: RegExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.registerForm = this.formBuilder.group({
        name: [null, Validators.required],
        email: [null,[Validators.required, Validators.pattern(emailregex)]],
        password: [null, [Validators.required, this.checkPassword]],
        confirmPassword: ['', Validators.required],
        usage: ['', Validators.minLength(50)],
        purpose: ['', Validators.required],
        // agree: ['', Validators.required]
    }, {
        validator:mustMatch('password', 'confirmPassword')
    });
   
  }
  get f() { return this.registerForm.controls; }

  getErrorEmail() {
    return this.registerForm.get('email').hasError('required')
      ? 'Field is required'
      : this.registerForm.get('email').hasError('pattern')
      ? 'Not a valid emailaddress'
      : '';
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  selectOption(option: string) {
    if(this.selectedOption === 'I am here for*'){
      this.selectedOption = "I am here for " + option;
    }
    else{
      this.selectedOption = '';
      this.selectedOption = "I am here for " + option;
    }
    this.registerForm.get('purpose')?.setValue(this.selectedOption);
    this.showDropdown = false;
  }
  dropdownOptions: string[] = [
    'creating a chatbot on SwiftChat',
    'creating a mini-app on SwiftChat',
    'hosting my chatbot on SwiftChat',
    'hosting my mini-app on SwiftChat'
  ];

  get usage() {
    return this.registerForm.get('usage');
  }

  isMinLengthValid(): boolean {
    const control = this.usage;
    return control?.hasError('minlength') && (control.dirty || control.touched);
  }
  checkPassword(control) {
    let enteredPassword = control.value;
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
    return !passwordCheck.test(enteredPassword) && enteredPassword
      ? { requirements: true }
      : null;
  }
  getErrorPassword() {
    return this.registerForm.get('password').hasError('required')
      ? 'Field is required (at least eight characters, one uppercase letter, one lowercase and one number)'
      : this.registerForm.get('password').hasError('requirements')
      ? 'Password needs to be atleast eight characters, one uppercase letter, one lowercase and one number'
      : '';
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid || this.registerForm.value.name == null || this.registerForm.value.email == null || this.registerForm.value.password == null) {
      return;
    }
    let _data = {
      "name": this.registerForm.value.name,
      "email": this.registerForm.value.email,
      "password": this.registerForm.value.password
    };
    const usage = this.registerForm.value.usage;
    const purpose = this.registerForm.value.purpose;
    if(usage.length > 0 && purpose.length > 0){
      _data["purpose"] = purpose;
      _data["usage"] = usage;
    }
    else if(usage.length > 0){
      _data["usage"] = usage;
    }
    else if(purpose.length > 0){
      _data["purpose"] = purpose;
    }
    console.log(_data)
    this.service.signUpUser(_data)
      .subscribe(
        result => {
          if (result.id) {
            // this.options.keepAfterRouteChange = true;
            // this.alertService.success(' Signup successful!! Check your inbox and click on the link to verify your email address.', this.options);
            this.service.setProduct(result.id);
            this.service.setUsername(this.registerForm.value.name);
            this.registerForm.reset();
            Object.keys(this.registerForm.controls).forEach(key => {
              this.registerForm.get(key).setErrors(null);
            });

            this.router.navigateByUrl('/')
            this._snackBar.open("Signup successful!! Check your inbox and click on the link to verify your email address.", 'close', {
               duration: 4000,
               horizontalPosition: this.horizontalPosition,
               verticalPosition: this.verticalPosition,
            })           
          } else {
            this.alertService.error('Failed', this.options);
          }
        },
        error => {
          this.alertService.error(error.error.message, this.options);
        }
      );
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }
  // openTermsAndConditions(){
  //   const dialogRef = this._matDialog.open(TermsAndConditionDialog, { data: this.registerForm });
  //   dialogRef.afterClosed().subscribe(result => {
  //   });
  // }

  goToLink(url: string){
    window.open(url, "_blank");
} 

  closePopup() {
  //  this.dialogRef.close({ event: 'close', data: undefined });
  }
  
}


@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationDialog {
  mailId: any;
  options = {
    autoClose: false,
    keepAfterRouteChange: true
  };
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private service: CommonServiceService,
    private _snackbar : MatSnackBar,
    private router: Router, public alertService: AlertService) {

  }
  resend() {
    this.service.resetPasswordLink(this.data.email)
      .subscribe(
        result => {
          this.alertService.success('Link shared', this.options);
        },
        error => {
          if (error.status === 429) {
            let message = 'Too many requests. Please try again after some time.';
            if (error.error) {
              if (typeof error.error === 'string') {
                try {
                  const parsed = JSON.parse(error.error);
                  message = parsed.message || message;
                } catch (e) {}
              } else if (typeof error.error === 'object' && error.error.message) {
                message = error.error.message;
              }
            }
            this._snackbar.open(message, 'close', {
              duration: 3000,
              verticalPosition: this.verticalPosition,
              horizontalPosition: this.horizontalPosition,
            });
          } else {
            this.alertService.error('Failed', this.options);
          }
        }
      );
  }

}

@Component({
  selector: 'termsCondition-dialog',
  templateUrl: 'termsCondition-dialog.html',
  styleUrls: ['./termsCondition-dialog.css']
})
export class TermsAndConditionDialog {
  mailId: any;
  options = {
    autoClose: false,
    keepAfterRouteChange: true
  };
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private service: CommonServiceService,
    private _matDialog: MatDialog,
    private router: Router, public alertService: AlertService) {

  }
  accept() {
    this.data.value.agree = true;
    this.data.get('agree').setValue(true);
    this._matDialog.closeAll();
  }
  reject () {
    this.data.value.agree = false;
    this.data.get('agree').setValue(false);
    this._matDialog.closeAll();
  }

}